// extracted by mini-css-extract-plugin
export var box = "_4w-0";
export var check = "_4w-1";
export var checkboxButton = "_4w-6";
export var checkboxGroup = "_4w-5";
export var disabled = "_4w-7";
export var ghost = "_4w-9";
export var input = "_4w-2";
export var label = "_4w-4";
export var normal = "_4w-8";
export var uncheck = "_4w-3";